const SelectInput = ({
  label,
  name,
  value = "",
  onChange,
  options = [],
  placeholder =
    "Select option",
  required = false,
  error = "",
  ...props
}) => {
  return (
    <label className="app-form-field">
      <span className="app-form-label">
        {label}

        {required && (
          <span aria-hidden="true">
            {" "}*
          </span>
        )}
      </span>

      <select
        name={name}
        value={value}
        onChange={
          onChange
        }
        required={
          required
        }
        {...props}
      >
        <option value="">
          {placeholder}
        </option>

        {options.map(
          (option) => (
            <option
              key={
                option.value
              }
              value={
                option.value
              }
            >
              {
                option.label
              }
            </option>
          )
        )}
      </select>

      {error && (
        <small className="app-form-error">
          {error}
        </small>
      )}
    </label>
  );
};

export default SelectInput;